//计划状态
const adsetStatus = [
  { value: '1',  label: '广告计划已暂停'},
  { value: '3',  label: '广告计划超预算'},
  { value: '4',  label: '有效'},
  { value: '5',  label: '广告计划已删除'},
]

export default {
  adsetStatus
}